import { FC } from 'react';
import { PaymentCardType } from '@mews/enums';
import { paymentCardsSvgString } from '@mews/framework';

interface PaymentCardIconProps {
    type: PaymentCardType;
    width?: number;
    disabled?: boolean;
}

const PaymentCardIcon: FC<PaymentCardIconProps> = ({ type, width = 40, disabled }) => {
    const paymentCardIconSrc = paymentCardsSvgString[type] ?? null;

    if (!paymentCardIconSrc) return null;

    return (
        <img
            alt="payment card icon"
            style={{
                opacity: disabled ? 0.3 : 1,
                filter: disabled ? 'grayscale(100%)' : 'none',
            }}
            src={paymentCardIconSrc}
            width={width}
        />
    );
};

export default PaymentCardIcon;
